import React from "react";
import { Form, Input, Select, Button, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

/**
 * 机场过滤器组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调函数
 * @param {Function} props.onReset - 重置回调函数
 */
const AirportFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    // 重置表单
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    // 提交表单
    const handleFinish = (values) => {
        onSearch(values);
    };

    return (
        <Form form={form} layout="horizontal" onFinish={handleFinish} className="filter-form" labelAlign="right">
            <Row gutter={24}>
                <Col span={5}>
                    <Form.Item label="IATA代码" name="code">
                        <Input placeholder="请输入IATA代码" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="ICAO代码" name="icao_code">
                        <Input placeholder="请输入ICAO代码" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="城市" name="city">
                        <Input placeholder="请输入城市" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="国家/地区" name="country">
                        <Input placeholder="请输入国家/地区" allowClear />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item label="状态" name="status">
                        <Select placeholder="请选择状态" allowClear>
                            <Option value="active">启用</Option>
                            <Option value="inactive">停用</Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ marginRight: 8 }}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>
                            重置
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default AirportFilter;
